/**
 * Local storage key for saving/retrieving lesson/assessment responses in STEM Sims topic assignments during Demo Mode
 */
export const ASSESSMENT_RESPONSES_LOCAL_KEY = "demoModeAssessmentResponses"
export const LESSON_RESPONSES_LOCAL_KEY = "demoModeLessonResponses"
